import palette from './palette';
import pxToRem from './pxToRem';

const base = {
    fontFamily: '"Fira Sans", sans-serif',
    fontSize: {
        10: pxToRem(10),
        11: pxToRem(11),
        12: pxToRem(12),
        14: pxToRem(14),
        16: pxToRem(16),
        18: pxToRem(18),
        24: pxToRem(24),
        32: pxToRem(32),
        40: pxToRem(40),
        48: pxToRem(48),
    },
    fontWeight: {
        normal: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    letterSpacing: {
        small: pxToRem(0.24),
        medium: pxToRem(0.4),
        upperMedium: pxToRem(0.64),
        big: pxToRem(0.8),
        superBig: pxToRem(1.6),
    },
};

const typography = {
    base,
    heading1: {
        fontFamily: base.fontFamily,
        fontWeight: base.fontWeight.bold,
        color: palette.primary,
        fontSize: base.fontSize[32],
        letterSpacing: base.letterSpacing.big,
        lineHeight: 1.25,
        margin: 0,
    },
    heading2: {
        fontFamily: base.fontFamily,
        fontWeight: base.fontWeight.bold,
        color: palette.primary,
        fontSize: base.fontSize[24],
        letterSpacing: base.letterSpacing.medium,
        lineHeight: 3,
        margin: 0,
    },
    heading3: {
        fontFamily: base.fontFamily,
        fontWeight: base.fontWeight.medium,
        color: palette.primary,
        fontSize: base.fontSize[24],
        letterSpacing: base.letterSpacing.medium,
        lineHeight: 1.33,
        margin: 0,
    },
    heading4: {
        fontFamily: base.fontFamily,
        fontWeight: base.fontWeight.bold,
        color: palette.data,
        fontSize: base.fontSize[16],
        letterSpacing: base.letterSpacing.medium,
        lineHeight: 1,
        margin: 0,
    },
    heading6: {
        fontFamily: base.fontFamily,
        fontWeight: base.fontWeight.bold,
        color: palette.data,
        fontSize: base.fontSize[16],
        letterSpacing: base.letterSpacing.medium,
        lineHeight: 3,
        margin: 0,
    },
};

export default typography;
